/** 自动曝光相关着色器：对数亮度、降采样、Pattanaik 自适应 */

/** 第一级：从 HDR 场景计算逐像素对数亮度（亮度夹紧避免纯黑像素主导曝光） */
export const logLuminanceShader = /* glsl */ `
precision highp float;
uniform sampler2D uTex;
varying vec2 vUv;
const vec3 LUMA = vec3(0.2126, 0.7152, 0.0722);
void main() {
  vec3 c = texture2D(uTex, vUv).rgb;
  float l = clamp(dot(c, LUMA), 0.01, 100.0);
  gl_FragColor = vec4(log(l), 0.0, 0.0, 1.0);
}
`

/** 降采样：对上一级 2x2 邻域的对数亮度取平均 */
export const downsampleShader = /* glsl */ `
precision highp float;
uniform sampler2D uTex;
uniform vec2 uPrevSize;
varying vec2 vUv;
void main() {
  vec2 texel = 1.0 / uPrevSize;
  vec2 uv0 = (gl_FragCoord.xy * 2.0 + 0.5) / uPrevSize;
  float s = (
    texture2D(uTex, uv0).r +
    texture2D(uTex, uv0 + vec2(1.0, 0.0) * texel).r +
    texture2D(uTex, uv0 + vec2(0.0, 1.0) * texel).r +
    texture2D(uTex, uv0 + vec2(1.0, 1.0) * texel).r
  ) * 0.25;
  gl_FragColor = vec4(s, 0.0, 0.0, 1.0);
}
`

/** Pattanaik 自适应曝光：输出 (自适应对数亮度, exposure) */
export const adaptationShader = /* glsl */ `
precision highp float;
uniform sampler2D uAvgLogLum; // 1x1
uniform sampler2D uPrev;      // 1x1 上一帧自适应值
uniform float uDeltaT;
uniform float uAdaptSpeed;
varying vec2 vUv;
void main() {
  float avg = texture2D(uAvgLogLum, vec2(0.5)).r;
  float prev = texture2D(uPrev, vec2(0.5)).r;
  float a = 1.0 - exp(-uDeltaT * uAdaptSpeed);
  float adapted = prev + a * (avg - prev);
  // 夹紧自适应对数亮度，避免曝光在 HalfFloat 中溢出为 Inf（太空/夜晚过暗场景）
  adapted = clamp(adapted, -6.0, 6.0);
  // 曝光 = 1/平均亮度：将场景几何平均亮度归一化到 1
  float exposure = clamp(exp(-adapted), 0.001, 1000.0);
  gl_FragColor = vec4(adapted, exposure, 0.0, 1.0);
}
`
